import type { QueryClient } from '@tanstack/react-query'

import { biddingQueryKeys } from '~/hooks/bidding/queryKeys'
import { isSpotFeePreviewStale } from '~/pages/SpotBidding/models/feePreview'

/**
 * 作成・下書きの保存が手数料の理由で拒否されたら、 個別作成が突き合わせている 3 つ (入札価格のプレビュー、
 * 入札制限の設定の ON/OFF、 手数料単価と会員の登録) を取り直す (AC-BSP-004b)。 単価の変更なら開いたままの
 * モーダルで表示し直した入札価格を確かめて登録し直せる。 ON/OFF の切り替えは、 開いている間は扱いを固定する
 * ([[useSpotFeeAutoConsider]]) ので開いたままでは食い違いの案内 (再読み込み) で止まり、 次に開いた時に新しい
 * ON/OFF で始まる (コマ選択のモーダルは拒否の後に閉じる)。 それ以外の拒否では何も取り直さない (undefined)。 通常入札の拒否理由で判定する。
 */
export function invalidateSpotFeePreviewsOnRejection(
  queryClient: QueryClient,
  err: unknown,
): Promise<unknown> | undefined {
  return invalidateFeePreviewsOnRejection(
    queryClient,
    err,
    isSpotFeePreviewStale,
  )
}

/**
 * [[invalidateSpotFeePreviewsOnRejection]] の、 拒否理由の判定を呼び出し側が渡す形 (ブロック入札は拒否理由の
 * enum が通常入札と別)。
 */
export function invalidateFeePreviewsOnRejection(
  queryClient: QueryClient,
  err: unknown,
  isStale: (err: unknown) => boolean,
): Promise<unknown> | undefined {
  if (!isStale(err)) return undefined
  return Promise.all(
    [
      biddingQueryKeys.spotFeeAdjustedPricePreview,
      biddingQueryKeys.bidLimitMatrix,
      biddingQueryKeys.jepxMemberInfo,
    ].map((queryKey) => queryClient.invalidateQueries({ queryKey })),
  )
}
